import React from 'react';
import { motion } from 'framer-motion';
export const Header = () => {
  return <header className="w-full flex justify-center items-center py-5 sm:py-8" data-id="element-83">
      <motion.img src="https://uploadthingy.s3.us-west-1.amazonaws.com/1nHp2mCuAECC1ybonVAGhz/hirewhite.png" alt="HIRE Logo" className="h-[2.5rem] sm:h-[3.25rem] mx-auto" initial={{
      opacity: 0,
      y: -10
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      duration: 0.5,
      ease: 'easeOut'
    }} data-id="element-84" />
    </header>;
};